<template>
  <v-menu
    v-model="monthsMenuOpen"
    min-width="auto"
    :disabled="disabled"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="formattedMonth"
        append-icon="mdi-calendar"
        class="report-month-input"
        readonly
        outlined
        hide-details
        v-bind="attrs"
        v-on="on"
        :label="label"
        @click:append="monthsMenuOpen = true"
      />
    </template>

    <v-card class="mt-14 mr-4" outlined rounded>
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="3">
            <v-list dense>
              <v-subheader class="pl-4">PRESETS</v-subheader>
              <v-list-item
                v-for="preset in presets"
                :key="preset.label"
                :class="{ 'primary white--text': month === preset.month }"
                @click="usePresetMonth(preset)"
              >
                <v-list-item-title>{{ preset.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-col>

          <v-divider vertical />

          <v-col cols="9" class="pl-1" >
            <v-date-picker v-model="month" type="month" no-title />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text class="primary" @click="monthsMenuOpen = false">
          Close
        </v-btn>
        <v-btn text class="green white--text" @click="applySelectedMonth">
          Apply
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MonthPicker',
  props: ['selectedMonth', 'label', 'disabled'],
  data() {
    const months = [];
    let lastMonth = '';

    // 6 nearest months
    for (let i = 6; i >= 1; --i) {
      const month = moment().subtract(i, 'months');
      months.push({
        label: i === 1 ? 'Last month' : month.format('MMM YYYY'),
        month: month.format('YYYY-MM'),
      });

      if (i === 1) {
        lastMonth = moment().subtract(1, 'months').format('YYYY-MM');
      }
    }

    return {
      monthsMenuOpen: false,
      month: this.selectedMonth ?? lastMonth,
      presets: months,
    };
  },
  computed: {
    formattedMonth() {
      if (!this.month) {
        return '';
      }

      return moment(this.month).format('MMMM YYYY');
    },
  },
  methods: {
    emitSelectEvent() {
      this.$emit('select-month', this.month);
    },
    usePresetMonth(preset) {
      this.month = moment(preset.month).format('YYYY-MM');
      this.monthsMenuOpen = false;
      this.emitSelectEvent();
    },
    applySelectedMonth() {
      this.monthsMenuOpen = false;
      this.emitSelectEvent();
    },
  },

  mounted() {
    this.emitSelectEvent();
  },
};
</script>

<style>
.report-month-input {
  max-width: 400px;
}
</style>
